// Shared response handling for wizard flows (QuoteWizard, BusinessLPWizard).
// Both POST to /api/lead and parse the same response: { ok, customerToken }.
// Isomorphic — no node imports, safe in "use client".

export type LeadResponse = { ok: true; customerToken?: string | null };

export async function parseLeadResponse(res: Response): Promise<LeadResponse | null> {
  return (await res.json().catch(() => null)) as LeadResponse | null;
}

// The customer's task page, or null when the submission did not land (the
// wizard then shows an error rather than a thank-you it cannot back up).
export function taskPagePath(body: LeadResponse | null): string | null {
  return body?.customerToken ? `/tilbud/${body.customerToken}` : null;
}
